import * as React from 'react';
import {Skeleton} from 'antd';

export const ImageSkeleton: React.FC = () => (
  <div className="flex h-full w-full justify-center items-center bg-gray rounded-t-lg skeleton-box">
    <Skeleton.Image style={{background: 'none'}} />
  </div>
);
